import React from "react";

const sizes = {
    h1: "font-display font-semibold tracking-tight-2 leading-[1.05] text-text-primary",
    h2: "font-display font-semibold tracking-tight-2 leading-[1.08] text-text-primary",
    h3: "font-display font-semibold leading-tight text-text-primary",
    h4: "font-display font-semibold leading-tight text-text-primary",
};

const fluid = {
    h1: "text-[clamp(40px,7vw,96px)]",
    h2: "text-[clamp(32px,4.4vw,56px)]",
    h3: "text-[clamp(22px,2.2vw,28px)]",
    h4: "text-[clamp(18px,1.6vw,22px)]",
};

export const Heading = ({
    as = "h2",
    children,
    className = "",
    fluidSize,
    ...props
}) => {
    const Tag = as;
    const sizeKey = fluidSize || as;
    return (
        <Tag
            className={`${sizes[as] || sizes.h2} ${fluid[sizeKey] || ""} ${className}`}
            {...props}
        >
            {children}
        </Tag>
    );
};

export default Heading;
